export default [
  {
    field: "name",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
  {
    field: "description",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
  {
    field: "activityType",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
];
